@if (survey?.hasConfirmationTitle) {
  <div class="title-container" fxLayout fxLayoutAlign="center center">
    <h1>{{ survey.form.confirmationTitle }}</h1>
  </div>
}
<div fxLayout="column" fxLayoutAlign="start center" class="message">
  <p
    [innerHTML]="
      survey?.hasConfirmation
        ? (survey.confirmation | safeHtml)
        : 'Thank you for completing the survey.'
    "
  ></p>
</div>
